import { h } from '@stencil/core';
import cn from 'classnames';
import { calculateFillPct } from './utils';
export class PesRainbowBar {
  constructor() {
    this.min = 0;
    this.max = 100;
    this.value = 50;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    const { min, max, value } = this;
    const pct = calculateFillPct({ min, max, value });
    const greyWidth = pct === 0 ? '100%' : `${100 - pct}%`;
    const isError = value > max;
    return (h("div", { class: "rainbow-bar" }, h("div", { class: cn('rainbow-bar__progress', {
        'rainbow-bar__progress--error': isError,
      }) }), h("div", { class: "rainbow-bar__gray", style: { width: greyWidth } })));
  }
  static get is() { return "pes-rainbow-bar"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-rainbow-bar.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-rainbow-bar.css"]
    };
  }
  static get properties() {
    return {
      "min": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "minimum value the progress bar starts to fill from"
        },
        "attribute": "min",
        "reflect": false,
        "defaultValue": "0"
      },
      "max": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Maximum value. Exceeding this value changes the bar color to fuchsia-red"
        },
        "attribute": "max",
        "reflect": false,
        "defaultValue": "100"
      },
      "value": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Current value indicated in progress bar."
        },
        "attribute": "value",
        "reflect": false,
        "defaultValue": "50"
      }
    };
  }
  static get elementRef() { return "el"; }
}
